import { TreeItem, TreeItemProps } from '@mui/x-tree-view';
import { BankAccountLine } from '../../types/bank-account/BankAccountLine';
import React from 'react';
import { Box } from '@mui/material';
import { DateRange, FiberManualRecord } from '@mui/icons-material';

export interface AccountLineTreeItemProps extends Omit<
  TreeItemProps,
  'itemId' | 'label'
> {
  line: BankAccountLine;
}

export const AccountLineTreeItemProps = (props: AccountLineTreeItemProps) => {
  const { line, children, ...rest } = props;

  return (
    <TreeItem
      {...rest}
      itemId={line.uuid}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {line._type === 'month' ? (
            <DateRange />
          ) : (
            <FiberManualRecord htmlColor={line.color} />
          )}
          <Box component="span" sx={{ marginLeft: 1 }}>
            {(line._type === 'month' ? line.name : line.description) ||
              '<vide>'}
          </Box>
        </Box>
      }
    >
      {children}
    </TreeItem>
  );
};
